import React from 'react';
import { CreditCard, ShieldCheck, Zap, Lock, Check } from 'lucide-react';
export const Offer = () => {
  return <section id="oferta" className="py-14 bg-legal-900 relative" data-id="element-125" data-mp="17xl3at5s4hn5">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-legal-800 via-legal-900 to-legal-900 pointer-events-none" data-id="element-126" data-mp="1mn94ludyngav"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-127" data-mp="1hqind3qf6env">
        <div className="text-center mb-8" data-id="element-128" data-mp="tzmpbovden86">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-129" data-mp="u0ocgrpnv069">
            Oferta Especial de Hoy
          </h2>
        </div>

        <div className="max-w-lg mx-auto bg-legal-800 rounded-2xl border-2 border-gold-500 shadow-[0_0_40px_rgba(201,162,74,0.15)] overflow-hidden" data-id="element-130" data-mp="13y2fnpmkpsgm">
          <div className="bg-gold-500 py-4 text-center" data-id="element-131" data-mp="z0aq329eiifl">
            <span className="text-legal-900 font-bold uppercase tracking-wider text-sm" data-id="element-132" data-mp="2fav5guvt06u1">
              Oferta Especial de Hoy
            </span>
          </div>

          <div className="p-8 md:p-10 text-center" data-id="element-133" data-mp="pkh4r5ywamdk">
            <p className="text-slate-400 mb-1" data-id="element-134" data-mp="pjz1vqhq99wo">
              Valor regular:{' '}
              <span className="line-through decoration-gold-500/70 decoration-2" data-id="element-135" data-mp="ui0je6zi9161">
                AR$ 221.430
              </span>
            </p>
            <div className="mb-6 pb-6 border-b border-legal-700" data-id="element-136" data-mp="13k01z3q64db3">
              <p className="text-sm text-slate-400 mb-1" data-id="element-137" data-mp="13j74ktd3n05m">Hoy:</p>
              <span className="text-5xl text-white leading-none font-[900] font-[Georgia,_serif]" data-id="element-138" data-mp="6uiqg84i7x1h">
                $ 24.990
              </span>
            </div>

            <div className="flex items-center justify-center gap-2 text-slate-300 mb-8" data-id="element-139" data-mp="fufimjq3re1a">
              <CreditCard className="w-5 h-5 text-gold-500" data-id="element-140" data-mp="fskvqzv9tbuk" />
              <span className="font-medium" data-id="element-141" data-mp="klxif4ge38ko">
                3 cuotas sin interés de AR$ 8.330
              </span>
            </div>

            <div className="mb-8 rounded-xl border border-legal-700 bg-legal-900/60 p-5 text-left" data-id="element-142" data-mp="3k6jak93re7xb">
              <p className="text-center text-xs font-bold uppercase tracking-widest text-gold-500 mb-4" data-id="element-143" data-mp="3o7uubxzybyxl">
                Tu compra incluye todo esto
              </p>
              <ul className="space-y-2.5" data-id="element-144" data-mp="qfuorqnacz6u">
                <li className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-145" data-mp="155k6oxjllhtt">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-146" data-mp="157mt77ljksts" />
                  <span data-id="element-147" data-mp="106z5ovwiuu4b">
                    <span className="font-semibold text-white" data-id="element-148" data-mp="108thnkptfbw9">
                      Los 6 módulos completos
                    </span>{' '}
                    del Tratado, listos para aplicar desde el primer caso.
                  </span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-149" data-mp="licf1y1g2fxs">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-150" data-mp="hfptufza3t9k" />
                  <span data-id="element-151" data-mp="1wwgaz9rlee5h">
                    <span className="font-semibold text-white" data-id="element-152" data-mp="1wvopirrplwsx">
                      Los 4 bonos profesionales
                    </span>{' '}
                    de regalo: modelos, kit para estudios, jurisprudencia y
                    estrategias.
                  </span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-153" data-mp="25erzo6nj4lg5">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-154" data-mp="1qgzlbhtpy33j" />
                  <span data-id="element-155" data-mp="1vfkmpkkpistk">
                    <span className="font-semibold text-white" data-id="element-156" data-mp="1vf174aij4gip">
                      Actualizaciones y acceso de por vida
                    </span>{' '}
                    a todo el material.
                  </span>
                </li>
              </ul>
            </div>

            <a href="https://tratado-practico-de-defensa-del-consumidor.impultienda.ar/checkout" className="block w-full py-5 hover:bg-gold-400 font-bold rounded-xl text-lg md:text-xl text-center transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg mb-8 text-[#F7F8FA] bg-[#4EC94A]" data-id="element-157" data-mp="29fbuh3kmrcz4">
              SÍ, QUIERO MI TRATADO AHORA
            </a>

            <div className="space-y-3 text-sm text-slate-400" data-id="element-158" data-mp="36vhle0ickr3z">
              <p className="flex items-center justify-center gap-2" data-id="element-159" data-mp="1j6xorhiuwh1r">
                <Lock className="w-4 h-4 text-gold-500" data-id="element-160" data-mp="1j41qtt70dsdb" />
                Compra 100% segura.
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-161" data-mp="1988hsjsi0h0a">
                <Zap className="w-4 h-4 text-gold-500" data-id="element-162" data-mp="198gqdzhl905o" />
                Acceso inmediato.
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-163" data-mp="14b8c49zk9g9p">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-164" data-mp="21vktu01196fc" />
                Garantía de satisfacción de 7 días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};